import {
  Button,
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "@/components/ui";
import { ArrowLeft } from "lucide-react";
import { useState } from "react";
import { ActionRegistryView } from "./ActionRegistryView";
import { PhaseRegistryView } from "./PhaseRegistryView";

export function PhaseProjectLibraryView({
  onBack,
  backLabel,
}: {
  onBack: () => void;
  backLabel: string;
}) {
  const [activeTab, setActiveTab] = useState("phases");

  return (
    <div className="space-y-6">
      <Button
        type="button"
        variant="ghost"
        className="-ml-3 gap-2"
        onClick={onBack}
      >
        <ArrowLeft className="size-4" /> {backLabel}
      </Button>
      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList>
          <TabsTrigger value="phases">Reusable phases</TabsTrigger>
          <TabsTrigger value="actions">Actions and widgets</TabsTrigger>
        </TabsList>
        <TabsContent value="phases" className="mt-6">
          <PhaseRegistryView />
        </TabsContent>
        <TabsContent value="actions" className="mt-6">
          <ActionRegistryView />
        </TabsContent>
      </Tabs>
    </div>
  );
}
